module.exports = __webpack_public_path__ + "pc/img/rec_10.b659f0e2.svg";